Pluswerk.PlusProject.FeManager = Pluswerk.PlusProject.FeManager || {};

/**
 * FeUserController
 *
 * @author Benjamin Stiber <benjamin.stiber@pluswerk.ag>
 */
Pluswerk.PlusProject.FeManager.FeUserController = function () {
    var doctype = '1598532674';
    var $metaElement = $('.js-header-user')[0];
    if ($metaElement) {
        $.ajax({
            type: 'GET',
            url: '/?type=' + doctype,
            success: function (data) {
                $metaElement.innerHTML = data;
            },
        });
    }
};
